import React, {forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useTranslation} from 'react-i18next'
import {useLocation, useNavigate, useParams, useSearchParams} from 'react-router-dom'
import {cloneDeep} from 'lodash'
import {Empty, Input, Menu, message, Select, Checkbox} from 'antd'

import './index.less'
import './mobile.less'
import {
  checkLogin,
  getDecodeStr,
  getEncodeStr,
  getFormatProductListByCartList,
  getProductItemBtnType,
  getUsingClassName,
} from '@/common'
import {PRODUCT_DEFAULT_LIMIT, LANGUAGE_CHINESE_KEY} from '@/constants'

import storeIcon from '@/assets/img/icon/store.png'
import searchIcon from '@/assets/img/icon/search.png'
import Loading from '@/components/Loading'
import CategoryItem from '@/components/CategoryItem'
import ProductItem from '@/components/ProductItem'
import {
  addProductToFavoriteList,
  getAllProducts,
  getCategoryProducts,
  getGroupProducts,
  getCat2Products,
  removeProductFromFavoriteList
} from '@/api/req-api'
import {addProductToCart, removeCartItem, updateCartItemQuantity} from '@/store/modules/cart.slice'

const searchKey = 'name'
const iconStyle = {width: '16px', height: '16px', verticalAlign: 'text-top'}
const stockOptions = [
  {
    value: 'all',
    label: 'All',
  },
  {
    value: 'instock',
    label: 'In Stock',
  },
  {
    value: 'outofstock',
    label: 'Out of Stock',
  },
]
const sortByOptions = [
  {
    value: 'Name',
    label: 'Product Name',
    icon: <img src={require('../../assets/img/icon/arrowUp.png')} style={iconStyle} alt={'Product Name'}/>,
  },
  {
    value: '-Name',
    label: 'Product Name',
    icon: <img src={require('../../assets/img/icon/arrowDown.png')} style={iconStyle} alt={'Product Name'}/>,
  },
  {
    value: 'Price',
    label: 'Price',
    icon: <img src={require('../../assets/img/icon/arrowUp.png')} style={iconStyle} alt={'Price'}/>,
  },
  {
    value: '-Price',
    label: 'Price',
    icon: <img src={require('../../assets/img/icon/arrowDown.png')} style={iconStyle} alt={'Price'}/>,
  },
  // {
  //   value: 'StockLevel',
  //   label: 'Stock',
  //   icon: <img src={require('../../assets/img/icon/arrowUp.png')} style={iconStyle} alt={'Price'}/>,
  // },
  // {
  //   value: '-StockLevel',
  //   label: 'Stock',
  //   icon: <img src={require('../../assets/img/icon/arrowDown.png')} style={iconStyle} alt={'Price'}/>,
  // },
]
const productLimit = PRODUCT_DEFAULT_LIMIT

const defaultProps = {
  className: '',
  rootPath: '',
  scrollTop: 0,
  isEditOrder: false,
  cartProductList: [],
  onAddProduct: () => {},
  onEditProduct: () => {},
  onRemoveProduct: () => {},
};

const ProductsContent = forwardRef(function (props, ref) {
  const options = Object.assign({}, defaultProps, props)
  const {
    rootPath,
    scrollTop,
    isEditOrder,
    cartProductList,
    onAddProduct,
    onEditProduct,
    onRemoveProduct,
  } = options

  const {group, category, category2} = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()
  const {t} = useTranslation()

  const searchName = searchParams.get(searchKey)
  const name = searchName ? getDecodeStr(searchName) : ''
  const commonState = useSelector(state => state.common)
  const {productGroupMenu, productCategoryMap, productGroupMap, isLogged, isInternal, locale} = commonState
  const rootClassName = commonState.isMobile ? 'products-content-mobile-container' : 'products-content-container'
  const isCat2Page = category2 !== undefined
  const productGroupMapKeys = Object.keys(productGroupMap)
  const productCategoryMapKeys = Object.keys(productCategoryMap)

  const groupRef = useRef()
  const filterRef = useRef()
  const maskRef = useRef()
  const searchInputRef = useRef()
  const touchBottom = useRef()
  const breadCrumbRef = useRef()
  const prevCategoryIdsRef = useRef('')

  const [isMulti, setIsMulti] = useState(true);
  const [groupDetail, setGroupDetail] = useState({})
  const [menuList, setMenuList] = useState([])
  const [categoryDetail, setCategoryDetail] = useState({})
  const [products, setProducts] = useState([])
  const [categories, setCategories] = useState([]) // this not been used

  const [selectedKeys, setSelectedKeys] = useState([]) // category ids, used for menu highlight + fetch + URL
  const [openKeys, setOpenKeys] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchVal, setSearchVal] = useState('')
  const [brandOptions, setBrandOptions] = useState([])
  const [brandVal, setBrandVal] = useState('')
  // 设置默认值为null，只有初次进页面会是默认值，清除选择后为undefined
  const [sortByVal, setSortByVal] = useState('Name')
  const [sortByStock, setSortByStock] = useState('all')
  const [selectPrint, setSelectPrint] = useState(false)
  const [selectedPrintIds, setSelectedPrintIds] = useState([])
  const [isPrinting, setIsPrinting] = useState(false)
  // 设置默认值为0，只有初次进页面会是默认值，切换组或者分类会设置为1
  const [pageNum, setPageNum] = useState(0)
  const [totalPages, setTotalPages] = useState(0)
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 0
  )

  const useProducts = useMemo(() => {
    return getFormatProductListByCartList(products, cartProductList)
  }, [products, cartProductList])

  const visibleProducts = useMemo(() => {
    // return useProducts.filter(item => item.InventoryQuantity > item.MinQuantity)
    const list = Array.isArray(useProducts) ? useProducts : []
    return list.filter(item => item.InventoryQuantity > 0 || item.IsOverSaleable);
  }, [useProducts])

  useEffect(() => {
    if (!commonState.isMobile) {
      window.addEventListener('scroll', handlePageScroll)
      return () => {
        window.removeEventListener('scroll', handlePageScroll)
      }
    }
  }, [])

  useEffect(() => {
   if (!selectPrint) return
   // When the product list changes (category/filter), reset selection.
   setSelectPrint(false)
   setSelectedPrintIds([])
 }, [visibleProducts])

  useEffect(() => {
    const handleAfterPrint = () => setIsPrinting(false)
    window.addEventListener('afterprint', handleAfterPrint)
    return () => {
      window.removeEventListener('afterprint', handleAfterPrint)
    }
  }, [])

  useEffect(() => {
    setSearchVal(name)
  }, [name])
  
  useEffect(() => {
    const selectedCategoryIds = selectedKeys.filter(id => productCategoryMap[id])
    const ids = selectedCategoryIds.join(',')
    // when size is cleared, reload the unfiltered category list
    if (ids) {
      initPageData()
    }
  }, [brandVal])

  // no use anymore
  const fetchGroupProducts = (groupId, sort, stock, pageNum, searchVal) => {
    setLoading(true)
    getGroupProducts(groupId, sort, stock, pageNum).then(response => {
      const resData = response.data || [];
      let newList = []
      if (pageNum > 1) {
        newList.push(...products)
      }
      newList.push(...resData)
      setProducts(newList)
      setLoading(false)
    })
  }

  const fetchCategoryProducts = (categoryId, sort, stock, brand, searchVal, options = {}) => {
    const { refreshBrandOptions = false } = options
    setLoading(true)
    getCategoryProducts(categoryId, sort, stock, brand, searchVal).then(response => {
      const resData = response.data.list || [];
      const newList = []
      if (pageNum > 1) {
        newList.push(...products)
      }
      newList.push(...resData)
      
      if (refreshBrandOptions) {
        handleBrandOptions(response.data.brands)
      }
  
      if (brand) {
        handleFilterProductsWithBrand(newList, brand)
      } else {
        setProducts(newList)
        setLoading(false)
      }
    })
    .catch(error => {
      console.error(error)
      setLoading(false)
    })
  }

  const fetchAllProducts = (name, sortByVal, sortByStock, pageNum) => {
    setLoading(true);
    // getAllProducts(name || undefined, sortByVal, sortByStock, pageNum).then(response => {
    //   const resData = response.data.Products || [];
    //   setTotalPages(response.data.pages)
    //   const newList = []
    //   if (pageNum > 1) {
    //     newList.push(...products)
    //   }
    //   newList.push(...resData)
    //   setProducts(newList)
    //   setLoading(false)
    // })
  }

  const fetchCat2Products = (category2Id) => {
    // no pagiantion for cate2 b2b list
    setLoading(true)
    getCat2Products(category2Id).then(response => {
      const resData = response.data || [];
      const newList = []
      newList.push(...resData)
      setProducts(newList)
      setLoading(false)
    })
  }

  const initPageData = () => {
    if (productGroupMapKeys.length <= 0) {
      return
    }

    // if (!group) {
    //   // group will show category instead of products
    //   // fetchAllProducts(name, sortByVal, sortByStock, pageNum)
    //   return
    // }
    
    // const groupId = productGroupMapKeys.find(key => productGroupMap[key].Name.toLowerCase() === getDecodeStr(group).toLowerCase())
    // if (!groupId) return;
    // const groupKey = productGroupMap[groupId].Name;

    // get categories from query string
    const categoryIdsFromUrl = searchParams.get('categories')?.split(',') || [];
    const categoryIdsKey = categoryIdsFromUrl.join(',');
    const categoryChanged = prevCategoryIdsRef.current !== categoryIdsKey;
    const keysFromUrl = categoryIdsFromUrl.filter(id => productCategoryMap[id]);

    if (categoryChanged) {
      prevCategoryIdsRef.current = categoryIdsKey;
      if (brandVal) setBrandVal('')
      resetProductFilters()
    }

    setSelectedKeys(keysFromUrl);
    // setGroupDetail(productGroupMap[groupId])
    // setOpenKeys([groupKey])

    // if categories are selected (multi-select mode)
    if (keysFromUrl.length > 0) {
      setLoading(true);
      const ids = categoryIdsFromUrl.join(',');
      // const effectiveBrandVal = categoryChanged ? '' : brandVal;
      const effectiveBrandVal = categoryChanged ? '' : (brandVal || '');
      fetchCategoryProducts(ids, sortByVal, sortByStock, effectiveBrandVal, searchVal, {
        refreshBrandOptions: categoryChanged || !effectiveBrandVal
      })
      return;
    }

    // otherwise, check for group/category logic as before
    if (category2) {
      fetchCat2Products(category2)
      return
    }

    // setGroupDetail(productGroupMap[groupId])
    // setOpenKeys([groupKey])
    // group will show gorup's product
    // fetchGroupProducts(groupId, sortByVal, sortByStock, pageNum);
    // group will show category instead of products
    // setCategories(productGroupMap[groupId].Categories);
    setLoading(false)
  }

  useEffect(() => {
    // 如果是默认值，不需要调接口，别的地方会调
    if (pageNum < 1) {
      return
    }
    initPageData()
  }, [pageNum])
  useEffect(() => {
    // 如果是默认值，不需要调接口，别的地方会调
    if (sortByVal === null) {
      return
    }
    initPageData()
  }, [sortByVal])

  useEffect(() => {
    if (pageNum !== 1) {
      return setPageNum(1)
    }
    initPageData()
  }, [group, category, productCategoryMap, name, sortByStock, searchParams.toString()])

  useEffect(()=>{
    if(productGroupMenu.length > 0) {
      let tList = [];
      productGroupMenu.map((item)=>{
        if(locale === LANGUAGE_CHINESE_KEY) {
          let chList = [];
          item.children && item.children.length > 0 && item.children.map((childIt)=>{
            chList.push({key: childIt.key, label: childIt.description})
          })
          tList.push({
            key: item.key,
            children: chList,
            label: item.description,
            className: 'products-menu-group-disabled',
          })
        } else {
          tList.push({
            key: item.key,
            children: item.children,
            label: item.name, 
            className: 'products-menu-group-disabled',
          })
        }
      })
      setMenuList(tList)
      setOpenKeys(tList.map(item => item.key))
    }
  },[productGroupMenu, locale])

  const windowScrollTop = () => {
    let timeOut = setTimeout(() => {
      window.scrollTo(0, 0)
      clearTimeout(timeOut)
    }, 200);
  }
  
  const resetProductFilters = () => {
    setSortByVal('-Stock')
    setBrandVal('')
  }

  const handleMenuClick = event => {
    {/* }// old code 
    if (commonState.isMobile) {
      handleFilterClick();
    }
    const categoryKey = event.key.toLowerCase()
    navigate(`${rootPath}/${groupDetail.Name.toLowerCase()}/${categoryKey}`, {replace: true})
    // old code end */}

    setCategories([]);
    windowScrollTop();
    const categoryId = event.key
    if (!productCategoryMap[categoryId]) return;

    setSelectedKeys(prevKeys => {
      const exists = prevKeys.includes(categoryId);
      let newKeys;
      if (isMulti) {
        if (exists) {
          // unselect if already selected
          newKeys = prevKeys.filter(key => key !== categoryId);
        } else {
          // add new selection
          newKeys = [...prevKeys, categoryId];
        }
      } else {
        newKeys = [categoryId];
      }

      const newIds = newKeys;
      // build URL query string
      const params = new URLSearchParams();

      if (newIds.length > 0) {
        params.set('categories', newIds.join(','));
      }

      // optional: preserve search by name
      // const search = searchInputRef.current?.input?.value;
      // if (search) {
      //   params.set('name', getEncodeStr(search));
      // }

      // navigate(`${rootPath}/${groupDetail.Name.toLowerCase()}?${params.toString()}`, { replace: true });
      navigate(`${rootPath}?${params.toString()}`, { replace: true });
      
      return newKeys;
    });
  };

  const handleMenuOpen = (keys) => {
    setOpenKeys(menuList.map(item => item.key))
    // const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    // if (latestOpenKey) {
    //   setOpenKeys([latestOpenKey])
    //   setSelectedKeys([]);
    //   navigate(`${rootPath}/${latestOpenKey.toLowerCase()}`, {replace: true})
    // } else {
    //   setOpenKeys([])
    // }
    // windowScrollTop();
  }

  const handleCategoryItemClick = item => {
    // here is issue if click from group image
    setCategories([]); // reset show categories
    resetProductFilters()
    // handleMenuClick with diffferent categoryKey
    const categoryId = item.ProductCategory_id || productCategoryMapKeys.find(
      key => productCategoryMap[key].Name === item.Name
    );
    if (!categoryId) return;

    setSelectedKeys(prevKeys => {
      let newKeys;
      newKeys = [String(categoryId)];
      
      const newIds = newKeys;
      // build URL query string
      const params = new URLSearchParams();
      
      if (newIds.length > 0) {
        params.set('categories', newIds.join(','));
      }
      if (newIds.length === 1) {
        setCategoryDetail(productCategoryMap[newIds[0]]);
      }

      // navigate(`${rootPath}/${groupDetail.Name.toLowerCase()}?${params.toString()}`, { replace: true });
      navigate(`${rootPath}?${params.toString()}`, { replace: true });

      return newKeys;
    });
  }

  const handleProductItemClick = item => {
    if (selectPrint) {
      const itemId = item.Product_id || item.ProductNum
      setSelectedPrintIds(prev => {
        if (prev.includes(itemId)) {
          return prev.filter(id => id !== itemId)
        }
        return prev.concat(itemId)
      })
      return
    }
    
    if (isEditOrder) {
      const path = `/editOrderProductDetail/${item.ProductNum}`
      navigate(path)
      return
    }
    const path = `/productDetail/${item.ProductNum}`
    if (location.pathname === path) {
      return
    }
    navigate(path)
    // window.open(path, '_blank'); // open in new tab
  }

  // Min, Add, Edit for qty to cart
  const handleEditOrderMinBtnClick = (item, qty) => {
    const newQty = qty - 1
    if (newQty < 1) {
      return onRemoveProduct(item);
    }
    onEditProduct(item, newQty);
  }
  const handleMinBtnClick = (item, qty) => {
    if (isEditOrder) {
      return handleEditOrderMinBtnClick(item, qty);
    }
    const newQty = qty - 1
    if (newQty < 1) {
      return dispatch(removeCartItem({item}));
    }
    dispatch(updateCartItemQuantity({item, quantity: newQty}));
  }
  const handleAddToCart = item => {
    if (isEditOrder) {
      return onAddProduct(item)
    }
    dispatch(addProductToCart({item}))
  }
  const handleEditToCart = (item, newQty) => {
    onEditProduct(item, newQty); // for edit 
    dispatch(updateCartItemQuantity({item, quantity: newQty})); // for ourproduct
  }

  const handleBeforeAddToCart = item => {
    checkLogin(
      navigate,
      isLogged,
      location,
      () => handleAddToCart(item)
    )
  }

  const handleChangeFavoriteStatus = item => {
    const isFavorite = item.IsFavorite
    const msg = isFavorite ? t('Cancel favorite successfully') : t('Add favorite successfully')
    const fun = isFavorite ? removeProductFromFavoriteList : addProductToFavoriteList
    const newProducts = cloneDeep(products)
    const idx = newProducts.findIndex(ite => ite.Product_id === item.Product_id)
    if (idx < 0) {
      return
    }
    fun(item).then(() => {
      message.success(msg)
      newProducts.splice(idx, 1, {...item, IsFavorite: !isFavorite})
      
      setProducts(newProducts)
    })
  }
  const handleBeforeChangeFavoriteStatus = (item, callback) => {
    checkLogin(
      navigate,
      isLogged,
      location,
      callback
    )
  }
  const handleFavoriteIconClick = item => {
    handleBeforeChangeFavoriteStatus(item, () => handleChangeFavoriteStatus(item))
  }

  const handleBreadcrumbGroupClick = () => {
    // setCategories([]);
    setSelectedKeys([]);
    // setSelectedIds([]);
    // setOpenKeys([]);
    // setCategoryDetail({});

    const groupKey = groupDetail.Name
    const groupId = productGroupMapKeys.find(
      key => productGroupMap[key].Name === groupKey
    );

    if (!groupId) return;
    
    setGroupDetail(productGroupMap[groupId]);
    const path = `/ourProducts/${groupKey.toLowerCase()}`
    navigate(path);
  }

  const handleClearFilterClick = () => {
    setSelectedKeys([]);
    // setOpenKeys([])
    setGroupDetail({})
    setCategoryDetail({})
    navigate(`${rootPath}`, {replace: true})
  }

  // const handleSearch = () => {
  //   // setOpenKeys([])
  //   // setGroupDetail({})
  //   // setCategoryDetail({})
  //   const keywords = searchInputRef.current.input.value
  // 
  //   const searchParams = new URLSearchParams({[searchKey]: getEncodeStr(keywords)})
  //   navigate(`${rootPath}?${searchParams}`, {replace: true})
  // 
  //   const selectedCategoryIds = Object.keys(productCategoryMap).filter(key =>
  //     selectedKeys.some(
  //       name => productCategoryMap[key].Name.toLowerCase() === name.toLowerCase()
  //     )
  //   )
  //   const ids = selectedCategoryIds.join(',')
  //   setLoading(true);
  //   Promise.all(
  //     fetchCategoryProducts(ids, sortByVal, sortByStock, searchVal)
  //   )
  //   .then(results => {
  //     const merged = results.flat();
  //     setProducts(merged);
  //     setLoading(false);
  //   })
  //   .catch(() => setLoading(false));
  // }
  
  // const handleSearchInputChange = event => {
  //   setSearchVal(event.target.value)
  // }

  const handleSortByChange = newSortByVal => {
    windowScrollTop();
    setSortByVal(newSortByVal)
  }

  const handleSortByStockChange = newSortByStock => {
    setSortByStock(newSortByStock);
  }

  const handleShowMore = () => {
    setPageNum(pageNum + 1)
  }

  const handleSelectPrintChange = (event) => {
    const checked = event?.target?.checked
    setSelectPrint(checked)
    if (checked) {
      const ids = visibleProducts.map(item => item.Product_id || item.ProductNum)
      setSelectedPrintIds(ids)
    } else {
      setSelectedPrintIds([])
    }
  }

  const handlePrintClick = () => {
    if (selectPrint && selectedPrintIds.length === 0) {
      message.error(t('you_can_at_print_without_a_product'))
      return
    }
    setIsPrinting(true)
    setTimeout(() => window.print(), 100)
  }

  const canPrint = selectPrint && selectedPrintIds.length > 0
  const showPrintControls = isInternal && (!commonState.isMobile || windowWidth >= 768)

  // brand filter
  const handleBrandOptions = (brands) => {
    const list = Array.isArray(brands)
    ? brands.map(brand => ({ value: brand, label: brand }))
    : [];
    
    setBrandOptions(list);

    // only clear size if it no longer exists
    if (brandVal && !list.some(opt => opt.value === brandVal)) {
      setBrandVal('');
    }
  }
  const handleBrandChange = newBrandVal => {
    windowScrollTop();
    setBrandVal(newBrandVal)
  }
  const handleFilterProductsWithBrand = (list, brand) => {
    // no need to filter from FE
    let newList = []
    list.map(item => {
      if (item.Brand === brand) {
        newList.push(item);
      }
    });
    setProducts(newList)
    setLoading(false)
  }
  
  // const renderRightSearchIcon = () => <div className={'products-content-right-search-icon-container'}>
  //   <img src={searchIcon} alt="" onClick={handleSearch}/>
  // </div>

  // product  isShowPrice={isLogged} -> false
  const renderProductGroupItem = (item, index) => <div
    className={
      `products-content-right-product-group-item-container${
        selectedPrintIds.includes(item.Product_id || item.ProductNum)
          ? ' is-print-selected'
          : ''
        }${
      selectPrint && !selectedPrintIds.includes(item.Product_id || item.ProductNum)
        ? ' print-hidden'
        : ''
      }`
    }
    key={`product_group_item_${index}`}>
    <ProductItem
      packageType={item.MeasureUnit}
      img={item.ThumbnailLarge || item.Thumbnail}
      price={item.Price}
      name={item.Name}
      description={item.Description}
      onProductItemClick={() => handleProductItemClick(item)}
      productType={item.ProductType}
      isShowPrice={true}
      onBtnClick={() => handleBeforeAddToCart(item)}
      isFormatPriceToMoney={true}
      isFavorited={item.IsFavorite}
      isShowFavorite={false}
      onFavoriteIconClick={() => handleFavoriteIconClick(item)}
      quantity={item.Quantity}
      btnType={getProductItemBtnType(item.Quantity)}
      onMinBtnClick={() => handleMinBtnClick(item, item.Quantity)}
      onPlusBtnClick={() => handleAddToCart(item)}
      onQtyChange={(newQty) => handleEditToCart(item, newQty)}
      isPromotion={item.IsPromotion}
      isOverSaleable={item.IsOverSaleable}
      discountDescription={item.DiscountDescription}
      originalPrice={item.OriginalPrice}
      stock={item.StockLevel}
      inventoryQuantity={item.InventoryQuantity}
    />
  </div>

  const renderProductGroup = () => {
    // const filteredProducts = useProducts.filter(
    //   item => item.InventoryQuantity > item.MinQuantity
    // );
    // const filteredProducts = useProducts.filter
    // const filteredProducts = visibleProducts;
    const filteredProducts = Array.isArray(useProducts)
    ? useProducts.filter(item => item.InventoryQuantity > 0 || item.IsOverSaleable)
    : []
  
    return (
      <div className={'products-content-right-product-group-container'}>
        {filteredProducts.length === 0 ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          <>
            <div className="products-content-right-product-group-list">
              {filteredProducts.map((item, index) =>
                renderProductGroupItem(item, index)
              )}
            </div>
            {products.length >= productLimit &&
              pageNum < totalPages &&
              !isCat2Page && (
                <div
                  className="products-content-right-product-group-btn"
                  onClick={handleShowMore}
                >
                  {t('Click to show more')}
                </div>
              )}
          </>
        )}
      </div>
    )
  }

  // group, not been used
  const renderGroupItem = (item, index) => <div
    className={'products-content-right-product-group-item-container'}
    key={`product_group_item_${index}`}>
    <CategoryItem
      img={item.image || item.image}
      name={item.name}
      description={item.description}
      onCategoryItemClick={() => handleGroupItemClick(item)}
    />
  </div>
  
  // handleMenuClick with diffferent groupKey, group image
  const handleGroupItemClick = item => {
    setCategories([]); // reset show categories
    setSelectedKeys([]);
    // setOpenKeys([]);
    setCategoryDetail({});
    const groupKey = item.name
    const groupId = productGroupMapKeys.find(
      key => productGroupMap[key].Name === groupKey
    );
    if (!groupId) return;

    setGroupDetail(productGroupMap[groupId]);
    const path = `/ourProducts/${groupKey.toLowerCase()}`
    navigate(path);
  }

  const renderGroup = () => <div className={'products-content-right-product-group-container'}>
    {
      !productGroupMenu.length &&
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
    }
    {
      !!productGroupMenu.length &&
      <>
        <div className={'products-content-right-product-group-list'}>
          {productGroupMenu.map((item, index) => renderGroupItem(item, index))}
        </div>
      </>
    }
  </div>

  // category
  const renderCategoryGroupItem = (item, index) => <div
    className={'products-content-right-product-group-item-container'}
    key={`product_group_item_${index}`}>
    <CategoryItem
      img={item.Image_Url || item.Image_Url}
      name={item.Name}
      description={item.Description}
      onCategoryItemClick={() => handleCategoryItemClick(item)}
    />
  </div>

  const renderCategoryGroup = () => <div className={'products-content-right-product-group-container'}>
    {
      !categories.length &&
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
    }
    {
      !!categories.length &&
      <>
        <div className={'products-content-right-product-group-list'}>
          {categories.map((item, index) => renderCategoryGroupItem(item, index))}
        </div>
      </>
    }
  </div>

  const handlePageScroll = event => {
    if(event.target.documentElement.scrollTop >= scrollTop) {
      if (!touchBottom.current) {
        // User scrolled down
        groupRef.current.classList.remove('stickBottom')
        groupRef.current.classList.add('fixed')
        // 
        // breadCrumbRef.current.classList.remove('stickTop')
        // breadCrumbRef.current.classList.add('fixed')
        // 
        // filterRef.current.classList.remove('stickTop')
        // filterRef.current.classList.add('fixed')
        // maskRef.current.classList.add('mask_fixed')
      } else {
        // Reached bottom
        groupRef.current.classList.add('stickBottom')
        // breadCrumbRef.current.classList.add('stickTop')
        // filterRef.current.classList.add('stickTop')
      }
    } else {
      // Scrolled up
      groupRef.current.classList.remove('fixed')
      // breadCrumbRef.current.classList.remove('fixed')
      // filterRef.current.classList.remove('fixed')
      // maskRef.current.classList.remove('mask_fixed')
    }
  }
  const handleFilterClick = () => {
    if (commonState.isMobile) {
      const filterDom = document.querySelector('.products-content-filter-container')
      const isExtended = filterDom.classList.contains('extended');
      if (isExtended) {
        filterDom.classList.remove('extended');
      } else {
        filterDom.classList.add('extended');
      }
    }
  }

  const className = getUsingClassName(
    [rootClassName],
    [options.className]
  )

  const getGroupBreadcrumb = () => {
    let group = groupDetail.Name ? ` > ${groupDetail.Name}` : '';
    return group ;
  }
  
  const getCategoryBreadcrumb = () => {
    let category = '';
    if (selectedKeys && selectedKeys.length === 1) {
      const selectedCategory = productCategoryMap[selectedKeys[0]];
      category = selectedCategory?.Name ? ` > ${selectedCategory.Name}` : '';
    }
    return category;
  }

  useImperativeHandle(ref, () => ({
    handlePageScroll
  }))
  const showClearFilter = location.pathname + location.search !== rootPath;
  
  return (
    <div className={`${className}${isPrinting ? ' print-mode' : ''}`}>
      {/* <div className={isCat2Page ? 'hide' : 'products_mask'} ref={maskRef}/> */}
      <div className={isCat2Page ? 'hide' : 'products-content-filter-container'} ref={groupRef}>
        <div className={'products-content-filter-top-container'} onClick={handleFilterClick}>
          {/*<div className={'products-content-filter-top-title'}>{t('Filter')}</div>
          <div
            className={'products-content-filter-top-clear-filter'}
            onClick={handleClearFilterClick}>
            {showClearFilter && t('Clear filter')}
          </div>*/}
          <div className={'products-content-filter-top-title'}>{t('Select')}</div>
          {/*<Checkbox checked={isMulti} onChange={(e) => setIsMulti(e.target.checked)}>
            <div className={'products-content-filter-top-clear-filter'}>
              {t('Multi Select')}
            </div>
          </Checkbox>*/}
        </div>
        <Menu
          className={'products-content-filter-menu-container'}
          onClick={handleMenuClick}
          style={{activeBarBorderWidth:0}}
          onOpenChange={handleMenuOpen}
          // activeKey={selectedKeys}
          selectedKeys={selectedKeys}
          // defaultSelectedKeys={defaultSelectedKeys}
          openKeys={openKeys}
          mode="inline"
          multiple={isMulti}
          items={menuList}
          expandIcon={() => null}
        />
      </div>
      <div className={(isCat2Page && !commonState.isMobile) ? 'products-content-one-container' : 'products-content-right-container'}>
        <div className={'products-content-right-title-container'}>
          <div className={'products-content-right-title-top'}>
            <div className={'products-content-right-title-icon-container'}>
              <img src={storeIcon} alt=""/>
            </div>
            <div onClick={handleClearFilterClick}>{t('All Product')}</div>
            {/*<div onClick={handleBreadcrumbGroupClick}>{getGroupBreadcrumb()}</div>*/}
            <div>{getCategoryBreadcrumb()}</div>
          </div>
          { selectedKeys.length > 0 &&
          <div className={'products-content-right-title-bottom'}>
            <div className={'products-content-right-search-sort-container'} ref={filterRef}>
              {/* 
              <Input
                ref={searchInputRef}
                className={'products-content-right-search-container'}
                suffix={renderRightSearchIcon()}
                placeholder={t('Search by Product Name')}
                onPressEnter={handleSearch}
                value={searchVal}
                onChange={handleSearchInputChange}
              />
              } */}
              <div className={'products-content-right-sort-container'}>
                <Select
                  className={'products-content-right-sort-select-container'}
                  popupClassName={'products-content-right-sort-select-popup-container'}
                  value={brandVal || undefined}
                  onChange={handleBrandChange}
                  placeholder={t('Select Brand')}
                  allowClear={true}>
                  {
                    brandOptions.map((item, index) => {
                      return <Select.Option
                        value={item.value}
                        key={`sort_by_options_${index}`}>
                          <span
                            className={'products-content-right-sort-select-option-label'}>
                            {t(item.label)}
                          </span>
                      </Select.Option>
                    })
                  }
                </Select>
              </div>
              <div className={'products-content-right-sort-container'}>
                {/* only show 'instock'
                <Select
                  className={'products-content-right-sort-select-container'}
                  popupClassName={'products-content-right-sort-select-popup-container'}
                  value={sortByStock}
                  onChange={handleSortByStockChange}
                  placeholder={t('Sort By')}>
                  {
                    stockOptions.map((item, index) => {
                      const currentSortOption = item.value.includes(sortByStock)
                      return <Select.Option
                        value={item.value}
                        key={`sort_by_options_${index}`}>
                          <span
                            className={'products-content-right-sort-select-option-label'}>
                            {t(item.label)}
                          </span>
                      </Select.Option>
                    })
                  }
                </Select>
                */}
                <Select
                  className={'products-content-right-sort-select-container'}
                  popupClassName={'products-content-right-sort-select-popup-container'}
                  value={sortByVal}
                  onChange={handleSortByChange}
                  // options={sortByOptions}
                  placeholder={t('Sort By')}
                  allowClear={true}>
                  {
                    sortByOptions.map((item, index) => {
                      const defaultVal = item.value.replace(/^-/, '')
                      const currentSortOption = item.value.includes(sortByVal)
                      const isDesc = sortByVal ? sortByVal.startsWith('-') : false
                      const isDescOption = item.value.startsWith('-')                  
                      let style = {}
                      if (currentSortOption) {
                        if (isDesc) {
                          if (isDescOption) {
                           style = {display: 'none'}
                          }
                        } else {
                          if (!isDescOption) {
                           style = {display: 'none'}
                          }
                        }
                      } else {
                        if (item.value !== defaultVal) {
                          style = {display: 'none'}
                        }
                      }
                      return <Select.Option
                        style={style}
                        value={item.value}
                        key={`sort_by_options_${index}`}>
                          <span className={'products-content-right-sort-select-option-label'}>
                            {t(item.label)}
                          </span>
                        {
                          item.icon &&
                          <span className={'products-content-right-sort-select-option-icon'}>
                            {item.icon}
                          </span>
                        }
                      </Select.Option>
                    })
                  }
                </Select>
              </div>
              <div className={'products-content-right-sort-container'}>
              {(showPrintControls && false) && (
                <div className="is-stockLevel">
                  <Checkbox checked={selectPrint} onChange={handleSelectPrintChange}>
                    {t('Select Print')}
                  </Checkbox>
                  <button
                    type="button"
                    className="print-button"
                    onClick={handlePrintClick}
                    disabled={!canPrint}
                  >
                    {t('Print')}
                  </button>
                </div>
              )}
              </div>
            </div>
          </div>
          }
        </div>
        <div className="products-scroll-area">
          {loading && <Loading text={'Loading Products'} />}
          {renderProductGroup()}
          {/*
          {
            !group
              ? renderGroup()
              : categories.length > 0
                ? renderCategoryGroup()
                : renderProductGroup()
          }*/}
        </div>
      </div>
    </div>
  )
})

export default ProductsContent
